import React from 'react';
import { Link } from 'react-router-dom'; // Assurez-vous d'avoir cette importation
import { motion } from 'framer-motion';

const ContactCTA = () => {
  return (
    <motion.div 
      className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-8 mb-12 text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.6 }}
    >
      <h2 className="text-3xl font-bold text-white mb-4">
        Prêt à démarrer votre projet ?
      </h2>
      <p className="text-white/80 mb-6 max-w-2xl mx-auto">
        Discutons de vos besoins et de la façon dont je peux vous aider à atteindre vos objectifs.
        Je suis à votre écoute pour créer une solution personnalisée.
      </p>
      
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Link to="/contact">
          <motion.button 
            className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg transition-colors transform group-hover:scale-105"
            animate={{ 
              boxShadow: [
                "0px 0px 0px rgba(255, 255, 255, 0)",
                "0px 0px 20px rgba(255, 255, 255, 0.5)",
                "0px 0px 0px rgba(255, 255, 255, 0)"
              ] 
            }}
            transition={{ duration: 2, repeat: Infinity, repeatType: "mirror" }}
          >
            Me contacter
          </motion.button>
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default ContactCTA;
